import { render } from "./RefillManagement.vue?vue&type=template&id=b047573c&scoped=true"
import script from "./RefillManagement.vue?vue&type=script&lang=js"
export * from "./RefillManagement.vue?vue&type=script&lang=js"

import "./RefillManagement.vue?vue&type=style&index=0&id=b047573c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b047573c"]])

export default __exports__